function getHeaders(csrfToken, isJson = true) {
  const headers = { 'X-CSRF-Token': csrfToken };
  if (isJson) headers['Content-Type'] = 'application/json';
  return headers;
}

export async function createDraft(csrfToken) {
  const res = await fetch('/api/admin/videos/drafts', {
    method: 'POST',
    headers: getHeaders(csrfToken),
    body: JSON.stringify({})
  });
  return res.json();
}

export async function autosaveVideo(csrfToken, videoId, autosaveToken, fields) {
  const hasFile = fields.thumbnail instanceof File;

  let body;
  let headers;

  if (hasFile) {
    const formData = new FormData();
    formData.append('autosave_token', autosaveToken);
    Object.entries(fields).forEach(([key, value]) => {
      if (key === 'tag_list' || key === 'category_list') {
        (value || []).forEach(v => formData.append(`video[${key}][]`, v));
      } else if (key === 'doctor_ids') {
        (value || []).forEach(v => formData.append(`video[${key}][]`, v));
      } else if (key === 'thumbnail' && value instanceof File) {
        formData.append('video[thumbnail]', value);
      } else if (value !== undefined && value !== null) {
        formData.append(`video[${key}]`, value);
      }
    });
    body = formData;
    headers = { 'X-CSRF-Token': csrfToken };
  } else {
    var videoFields = Object.assign({}, fields);
    if (videoFields.remove_thumbnail) videoFields.remove_thumbnail = 'true';
    body = JSON.stringify({ autosave_token: autosaveToken, video: videoFields });
    headers = getHeaders(csrfToken);
  }

  const res = await fetch(`/api/admin/videos/${videoId}/autosave`, {
    method: 'PATCH',
    headers,
    body
  });
  return { data: await res.json(), status: res.status };
}

export async function publishVideo(csrfToken, videoId, autosaveToken) {
  const res = await fetch(`/api/admin/videos/${videoId}/publish`, {
    method: 'POST',
    headers: getHeaders(csrfToken),
    body: JSON.stringify({ autosave_token: autosaveToken })
  });
  return { data: await res.json(), status: res.status };
}

export async function completeOnboarding(csrfToken) {
  const res = await fetch('/api/admin/videos/onboarding', {
    method: 'PATCH',
    headers: getHeaders(csrfToken),
    body: JSON.stringify({})
  });
  return res.json();
}

export { uploadEditorFile, searchDoctors, searchTags } from '../ArticleFormNew/api';

export async function fetchVideo(videoId) {
  var res = await fetch('/api/admin/videos/' + encodeURIComponent(videoId));
  var json = await res.json();
  return json.video || json;
}
